<div id="layout" class="theme-cyan">

  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Progress Bar</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <!-- Progress: How it works -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">How it works</h5>
              <p>Progress components are built with two HTML elements, some CSS to set the width, and a few attributes.
                We
                don’t use <a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/progress">the HTML5 <code
                    class="text-danger">&lt;progress&gt;</code> element</a>, ensuring you can stack progress bars,
                animate
                them, and place text labels over them.</p>
              <ul>
                <li>We use the <code class="text-danger">.progress</code> as a wrapper to indicate the max value of the
                  progress bar.</li>
                <li>We use the inner <code class="text-danger">.progress-bar</code> to indicate the progress so far.
                </li>
                <li>The <code class="text-danger">.progress-bar</code> requires an inline style, utility class, or
                  custom
                  CSS to set their width.</li>
                <li>The <code class="text-danger">.progress-bar</code> also requires some <code
                    class="text-danger">role</code> and <code class="text-danger">aria</code> attributes to make it
                  accessible.</li>
              </ul>
              <p>Put that all together, and you have the following examples.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="progress mb-2">
                    <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0"
                      aria-valuemax="100">
                    </div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; aria-valuenow=&quot;0&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 25%&quot; aria-valuenow=&quot;25&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 50%&quot; aria-valuenow=&quot;50&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 75%&quot; aria-valuenow=&quot;75&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 100%&quot; aria-valuenow=&quot;100&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Progress: Labels -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Labels</h5>
              <p>Add labels to your progress bars by placing text within the <code
                  class="text-danger">.progress-bar</code>.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25"
                      aria-valuemin="0" aria-valuemax="100">25%</div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 25%;&quot; aria-valuenow=&quot;25&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;25%&lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Progress: Height -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Height</h5>
              <p>We only set a <code class="text-danger">height</code> value on the <code
                  class="text-danger">.progress</code>, so if you change that value the inner <code
                  class="text-danger">.progress-bar</code> will automatically resize accordingly.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="progress mb-2" style="height: 1px;">
                    <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress" style="height: 20px;">
                    <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;progress&quot; style=&quot;height: 1px;&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 25%;&quot; aria-valuenow=&quot;25&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot; style=&quot;height: 20px;&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 25%;&quot; aria-valuenow=&quot;25&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Progress: Backgrounds -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Backgrounds</h5>
              <p>Use background utility classes to change the appearance of individual progress bars.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="progress mb-2" style="height: 3px;">
                    <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2" style="height: 3px;">
                    <div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2" style="height: 3px;">
                    <div class="progress-bar bg-warning" role="progressbar" style="width: 75%" aria-valuenow="75"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar bg-warning" role="progressbar" style="width: 75%" aria-valuenow="75"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2" style="height: 3px;">
                    <div class="progress-bar bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress">
                    <div class="progress-bar bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar bg-success&quot; role=&quot;progressbar&quot; style=&quot;width: 25%&quot; aria-valuenow=&quot;25&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar bg-info&quot; role=&quot;progressbar&quot; style=&quot;width: 50%&quot; aria-valuenow=&quot;50&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar bg-warning&quot; role=&quot;progressbar&quot; style=&quot;width: 75%&quot; aria-valuenow=&quot;75&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar bg-danger&quot; role=&quot;progressbar&quot; style=&quot;width: 100%&quot; aria-valuenow=&quot;100&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Progress: Multiple bars -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Multiple bars</h5>
              <p>Include multiple progress bars in a progress component if you need.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 15%" aria-valuenow="15" aria-valuemin="0"
                      aria-valuemax="100"></div>
                    <div class="progress-bar bg-success" role="progressbar" style="width: 30%" aria-valuenow="30"
                      aria-valuemin="0" aria-valuemax="100"></div>
                    <div class="progress-bar bg-info" role="progressbar" style="width: 20%" aria-valuenow="20"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 15%&quot; aria-valuenow=&quot;15&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
      &lt;div class=&quot;progress-bar bg-success&quot; role=&quot;progressbar&quot; style=&quot;width: 30%&quot; aria-valuenow=&quot;30&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
      &lt;div class=&quot;progress-bar bg-info&quot; role=&quot;progressbar&quot; style=&quot;width: 20%&quot; aria-valuenow=&quot;20&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Progress: Striped -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Striped</h5>
              <p>Add <code class="text-danger">.progress-bar-striped</code> to any <code
                  class="text-danger">.progress-bar</code> to apply a stripe via CSS gradient over the progress bar’s
                background color.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="progress mb-2" style="height: 3px;">
                    <div class="progress-bar progress-bar-striped" role="progressbar" style="width: 10%"
                      aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2" style="height: 3px;">
                    <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 25%"
                      aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2" style="height: 3px;">
                    <div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 50%"
                      aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2" style="height: 3px;">
                    <div class="progress-bar progress-bar-striped bg-warning" role="progressbar" style="width: 75%"
                      aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-4" style="height: 3px;">
                    <div class="progress-bar progress-bar-striped bg-danger" role="progressbar" style="width: 100%"
                      aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>

                  <div class="progress mb-2">
                    <div class="progress-bar progress-bar-striped" role="progressbar" style="width: 10%"
                      aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 25%"
                      aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 50%"
                      aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar progress-bar-striped bg-warning" role="progressbar" style="width: 75%"
                      aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="progress">
                    <div class="progress-bar progress-bar-striped bg-danger" role="progressbar" style="width: 100%"
                      aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar progress-bar-striped&quot; role=&quot;progressbar&quot; style=&quot;width: 10%&quot; aria-valuenow=&quot;10&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar progress-bar-striped bg-success&quot; role=&quot;progressbar&quot; style=&quot;width: 25%&quot; aria-valuenow=&quot;25&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar progress-bar-striped bg-info&quot; role=&quot;progressbar&quot; style=&quot;width: 50%&quot; aria-valuenow=&quot;50&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar progress-bar-striped bg-warning&quot; role=&quot;progressbar&quot; style=&quot;width: 75%&quot; aria-valuenow=&quot;75&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar progress-bar-striped bg-danger&quot; role=&quot;progressbar&quot; style=&quot;width: 100%&quot; aria-valuenow=&quot;100&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Progress: Animated stripes -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Animated stripes</h5>
              <p>The striped gradient can also be animated. Add <code class="text-danger">.progress-bar-animated</code>
                to
                <code class="text-danger">.progress-bar</code> to animate the stripes right to left via CSS3 animations.
              </p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="progress mb-2">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                      aria-valuenow="23" aria-valuemin="0" aria-valuemax="100" style="width: 23%"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                      aria-valuenow="33" aria-valuemin="0" aria-valuemax="100" style="width: 33%"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar"
                      aria-valuenow="72" aria-valuemin="0" aria-valuemax="100" style="width: 72%"></div>
                  </div>
                  <div class="progress mb-2">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar"
                      aria-valuenow="29" aria-valuemin="0" aria-valuemax="100" style="width: 29%"></div>
                  </div>
                  <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-danger" role="progressbar"
                      aria-valuenow="55" aria-valuemin="0" aria-valuemax="100" style="width: 55%"></div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;progress&quot;&gt;
      &lt;div class=&quot;progress-bar progress-bar-striped progress-bar-animated&quot; role=&quot;progressbar&quot; aria-valuenow=&quot;75&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot; style=&quot;width: 75%&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
